module.exports = __webpack_public_path__ + "static/media/Web head.eadf749b.jpeg";